import React from 'react'

import { borderColor } from 'styles/colors'

const Plus = ({ color = borderColor }) => (
  <svg width="12px" height="12px" viewBox="0 0 12 12">
    <g
      stroke="none"
      strokeWidth="1"
      fillRule="evenodd"
      transform="translate(-4.000000, -4.000000)"
      fill={color}>
      <polygon points="15.82 10.82 10.82 10.82 10.82 15.82 9.18 15.82 9.18 10.82 4.18 10.82 4.18 9.18 9.18 9.18 9.18 4.18 10.82 4.18 10.82 9.18 15.82 9.18" />
    </g>
  </svg>
)

export default Plus



// WEBPACK FOOTER //
// ./src/components/icons/Plus.js